import React, { Component } from 'react'
import Button from './Button'
import styles from './styles/button.scss'

export default class SmallButton extends Component {
  render() {
    const { text, onClick, disabled } = this.props

    return (
      <Button className={styles.buttonSmall} text={text} onClick={onClick} disabled={disabled} />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SmallButton.js